module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAAAXNSR0IArs4c6QAAAHxJREFUOE+91dENgCAQA9AylnO5o65lIIGAcFyLxPt/6Vd7AcAB4IZ4AcAJ4FJxhjFPwjWU8BvSeAQpbEEXz+AUe9DEDBxiFnZYgQ1WYcErMOFfYSqDmlgapMCmdizsusrAYcE9aK7C9lq5+7NtOtykPL+f55FOqhOXXsADgYs0j+y2icYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/status/01dailyActive/04right.png
// module id = VSKi
// module chunks = 0